<template>
<div id="homepage">
    <TopBar />
    <Header />
    <Timeline />
    <div id="services-title" class="container services-title">
        <div class="row">
            <div class="col-lg-12 text-center">
                <strong>QUE PUIS-JE FAIRE POUR VOUS ?<br></strong>
            </div>
        </div>
    </div>
    <transition name="fade" mode="out-in">
        <router-view />
    </transition>
    <ContactMe />
    <Footer />
</div>
</template>

<script>
import TopBar from './TopBar'
import Header from './Header'
import Timeline from './Timeline'
import Services from './Services'
import Footer from './Footer'
import ContactMe from './ContactMe'

export default {
    components: {
        TopBar,
        Header,
        Timeline,
        Services,
        Footer,
        ContactMe
    }
}
</script>

<style>

.services-title {
    padding-top: 5rem;
    background-color: #f5f5f5;
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

strong {
    font-size: 2rem;
    text-transform: uppercase;
}

@media (max-width: 992px) {
    strong {
        font-size: 1.6rem;
        text-transform: uppercase;
    }
}

@media (max-width: 576px) {
    strong {
        font-size: 1.4rem;
        text-transform: uppercase;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue